/* eslint-disable no-undef */
import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Link } from '@reach/router';
import { Divider } from 'antd';
import './Footer.scss';
import { RootState } from '@/redux/reducers';
import { getWebAppInfo } from '@/utils';
import env from '@/env';
import { footerItems } from './Footer.data';

interface FooterProps {
  params?: { [key: string]: string };
}

const Footer: React.FC<FooterProps> = ({ params }) => {
  const webApp = getWebAppInfo(env.siteId);
  const entity = useSelector((state: RootState) => state.serviceDirectoryEntity.entityViewOnly);
  const [footerMenus, setFooterMenus] = useState<
    { label: string; url: string; absolutePath?: boolean; show: boolean }[]
  >([]);
  const now = new Date();

  // const getFooterFields = (entity?: Entity, appParams?: ParamsUrl) => {
  //   if (entity && appParams?.subdomain) {
  //     const menus = footerItems.map((item) => {
  //       const url = (entity[item.field as keyof typeof entity] as string) || '';
  //       return {
  //         label: item.label,
  //         url: !url.includes('https://') ? `https://${url}` : url,
  //         absolutePath: regex.url.test(url),
  //         show: !!(url || item.show),
  //       };
  //     });
  //     return menus;
  //   }
  //   return footerItems;
  // };

  useEffect(() => {
    // const menus = getFooterFields(entity, params);
    setFooterMenus(footerItems);
    // eslint-disable-next-line
  }, [entity, params]);

  return (
    <div className="Footer">
      <div className="Footer-container container">
        {/* <div className="Footer-container container"> */}
        <div className="Footer-reserved">
          <span>
            © {now.getFullYear()} All Rights Reserved - {webApp.company}
          </span>
        </div>
        <Divider className="Footer-divider" />
        <div className="Footer-menus">
          {footerMenus?.map(
            (menu) =>
              menu.show &&
              (!menu.absolutePath ? (
                <Link className="Footer-menu" key={menu.label} to={menu.url}>
                  {menu.label}
                </Link>
              ) : (
                <a className="Footer-menu" key={menu.label} href={menu.url} target="_blank" rel="noopener noreferrer">
                  {menu.label}
                </a>
              ))
          )}
        </div>
      </div>
    </div>
  );
};

export default Footer;
